import { inject, Injectable } from '@angular/core'
import {
	ActivatedRouteSnapshot,
	CanActivate,
	CanActivateChild,
	GuardResult,
	MaybeAsync,
	Router,
	RouterStateSnapshot,
} from '@angular/router'
import { BreakpointsEnum } from '@shared/enums/breakpoints.enum'

@Injectable({
	providedIn: 'root',
})
export class MobileRedirectGuard implements CanActivate, CanActivateChild {
	protected readonly breakpointsEnum: typeof BreakpointsEnum = BreakpointsEnum
	protected readonly allowedURLs: string[] = [
		'/auth/sign-up',
		'/auth/sign-up/create-password',
		'/auth/sign-up/continue-in-app',
	]

	private readonly _router: Router = inject<Router>(Router)

	private _checkAllowedUrls(state: RouterStateSnapshot): boolean {
		return this.allowedURLs.some((allowedUrl: string): boolean => state.url.includes(allowedUrl))
	}

	private _canRedirect(state: RouterStateSnapshot): boolean {
		if (this._checkAllowedUrls(state)) return true

		const isLessThanMinWidth: boolean = window.innerWidth <= this.breakpointsEnum.MD
		const isMobileRedirectUrl: boolean = state.url.includes('mobile-redirect')

		if (isLessThanMinWidth && !isMobileRedirectUrl) {
			this._router.navigate(['mobile-redirect'])
			return false
		}

		if (!isLessThanMinWidth && isMobileRedirectUrl) {
			this._router.navigate(['/'])
		}

		return true
	}

	canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		return this._canRedirect(state)
	}

	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
		return this.canActivate(childRoute, state)
	}
}
